export const LanguagesLocale = {
  en: $localize`English`,
  es: $localize`Spanish`,
  'en-US': $localize`English`,
  'es-US': $localize`Spanish`,
  'es-MX': $localize`Spanish`,
};
